import { z } from "zod";
import {
  VARIABLE_PAY_CHIPS,
  VARIABLE_PAY_LINE_ACTIONS,
} from "@/features/payroll/schemas/variable-pay-payout.schema";

/**
 * URL search params for the batch review grid (FR-016, rule S3).
 *
 * A reviewer filtering to "held, no rating" and sharing the link should hand
 * a colleague the same view, so both chip rows live here rather than in
 * `useState`.
 */
export const variablePayPayoutRouteSearchSchema = z
  .object({
    payAction: z.enum(VARIABLE_PAY_LINE_ACTIONS).optional(),
    chip: z.enum(VARIABLE_PAY_CHIPS).optional(),
  })
  .strict();

export type VariablePayPayoutRouteSearch = z.infer<typeof variablePayPayoutRouteSearchSchema>;
